import Cart from '@/pages/Cart';
import Checkout from '../pages/Checkout';

export default [
  {
    path: '/cart',
    name: 'Cart',
    component: Cart
  },
  {
    path: '/cart/checkout',
    name: 'Checkout',
    component: Checkout
  }
];
